export const MAIN_PROVIDER_KEY = 'MAIN_PROVIDER_KEY';
export const ACTIONS_EVENT_NAMES = {
  open: 'open',
  close: 'close',
  closeAll: 'closeAll',
};
